import { Component } from '@angular/core';
import { FooterComponent } from '@cvx/nextpage';

@Component({
  standalone: true,
  imports: [FooterComponent],
  selector: 'app-footer',
  styleUrl: './footer.scss',
  templateUrl: './footer.html',
})
export class Footer {
  readonly currentYear = new Date().getFullYear();
}
